const EnumSistemasRelatorio = {
    SST: 29,
    TB: 21,
    RH: 12
};
  
export default EnumSistemasRelatorio;
  